<template>
  <v-container>
    <div class="headline-container">
      <v-row>
        <v-col cols="12" md="6">
          <span class="headline">Pengaturan Kode Surat</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="3">
          <v-btn
            width="100%"
            rounded
            color="primary"
            @click="formVisible = true"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Kode Surat Baru
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-layout row>
      <v-flex id="t">
        <v-card class="pa-0 ml-2" height="100%">
          <v-card-text class="pa-0">
            <v-container grid-list-md>
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="kodeSuratQuery"
                    append-icon="mdi-magnify"
                    label="Cari Kode Surat"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :loading="loadingKodeSurat"
                :headers="headers"
                :items="data"
                hide-default-footer
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="row-column">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          icon
                          light
                          @click="edit(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          icon
                          light
                          color="error"
                          @click="askDelete(item)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Hapus</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <v-pagination
                v-model="pagination.current_page"
                :length="pagination.last_page"
                :total-visible="7"
              ></v-pagination>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="formVisible" max-width="350px">
      <v-form v-model="formValid" ref="form">
        <v-card :loading="submiting">
          <v-card-title v-if="form.id">Edit Kode Surat</v-card-title>
          <v-card-title v-else>Input Kode Surat Baru</v-card-title>
          <v-card-text>
            <v-container grid-list-xl>
              <v-row no-gutters>
                <v-col class="py-1" cols="12">
                  <v-text-field
                    v-model="form.kode"
                    label="Kode Surat"
                    prepend-icon="mdi-counter"
                    :error="errors.has('kode')"
                    :error-messages="errors.get('kode')"
                  />
                </v-col>
                <v-col class="py-1" cols="12">
                  <v-textarea
                    v-model="form.jenis"
                    label="Keterangan Kode"
                    :error="errors.has('jenis')"
                    :error-messages="errors.get('jenis')"
                    prepend-icon="mdi-information-outline"
                    rows="2"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              v-if="!submiting"
              @click="formVisible = false"
            >
              Tutup
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="submiting"
              @click="submitForm"
            >
              {{ form.id ? 'Perbaharui' : 'Simpan' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="alertDelete" persistent max-width="350">
      <v-card :loading="submiting">
        <v-card-title>Yakin Hapus Kode Surat Ini?</v-card-title>
        <v-card-text>{{ deleting.kode }} - {{ deleting.jenis }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="alertDelete = false">
            Tidak
          </v-btn>
          <v-btn color="red darken-1" text @click="submitDelete"
            >Ya, Hapus</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Errors from '@/utils/errors'
import {
  saveKlasifikasiSurat,
  updateKlasifikasiSurat,
  deleteKlasifikasiSurat,
  getListKodeSurat
} from '@/services/surat'
import { debounce } from 'lodash'

const initialForm = {
  id: null,
  kode: '',
  jenis: ''
}

export default {
  data() {
    return {
      headers: [
        {
          text: 'Kode',
          value: 'kode',
          align: 'left'
        },
        {
          text: 'Keterangan',
          value: 'jenis',
          align: 'left'
        },
        {
          text: '',
          value: 'actions',
          align: 'right'
        }
      ],
      kodeSuratQuery: '',
      data: [],
      pagination: {
        current_page: 1,
        last_page: 1
      },
      loadingKodeSurat: false,
      formVisible: false,
      form: { ...initialForm },
      errors: new Errors(),
      formValid: false,
      submiting: false,
      alertDelete: false,
      deleting: {},
      errorLoading: ''
    }
  },
  computed: {},
  mounted() {
    this.loadKodeSurat()
  },
  watch: {
    formVisible: function(visible) {
      if (!visible) {
        this.reset()
      }
    },
    kodeSuratQuery: debounce(function() {
      this.loadKodeSurat()
    }, 500),
    'pagination.current_page': function(page) {
      this.loadKodeSurat(page)
    }
  },
  methods: {
    async loadKodeSurat(page = 1) {
      try {
        this.loadingKodeSurat = true
        const params = { page, q: this.kodeSuratQuery }
        const res = await getListKodeSurat(params)
        const { data, ...pagination } = res.data
        this.data = data
        this.pagination = pagination
      } catch (e) {
        this.errorLoading = e
      } finally {
        this.loadingKodeSurat = false
      }
    },
    reset() {
      this.errors.clears()

      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
      this.form = { ...initialForm }
    },
    async submitForm() {
      this.errors.clears()

      const isValid = this.$refs.form.validate()
      if (!isValid) {
        return
      }

      try {
        this.submiting = true
        if (this.form.id) {
          await updateKlasifikasiSurat(this.form.id, this.form)
        } else {
          await saveKlasifikasiSurat(this.form)
        }
        this.formVisible = false
        this.$emit('handle-snackbar', 'Kode surat berhasil disimpan', 'success')
        this.$emit('submited')
        this.loadKodeSurat(this.pagination.current_page)
      } catch (error) {
        this.$emit('handle-snackbar', 'Gagal menyimpan kode surat', 'error')
        if (error.status == 422) {
          this.errors.record(error.data)
        }
      } finally {
        this.submiting = false
      }
    },
    edit(item) {
      this.form = {
        id: item.id,
        kode: item.kode,
        jenis: item.jenis
      }
      this.formVisible = true
    },
    askDelete(item) {
      this.alertDelete = true
      this.deleting = item
    },
    async submitDelete() {
      try {
        this.submiting = true
        await deleteKlasifikasiSurat(this.deleting.id)
        this.alertDelete = false
        this.$emit('handle-snackbar', 'Kode surat berhasil dihapus', 'success')
        this.$emit('submited')
        this.loadKodeSurat(this.pagination.current_page)
      } catch (error) {
        this.$emit('handle-snackbar', 'Gagal menghapus kode surat', 'error')
        if (error.status == 422) {
          this.errors.record(error.data)
        }
      } finally {
        this.submiting = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.row-column
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center
</style>
